var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDeleteSquare(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 20C8.22876 20 6.34315 20 5.17157 18.8284C4 17.6569 4 15.7712 4 12C4 8.22876 4 6.34315 5.17157 5.17157C6.34315 4 8.22876 4 12 4C15.7712 4 17.6569 4 18.8284 5.17157C20 6.34315 20 8.22876 20 12C20 15.7712 20 17.6569 18.8284 18.8284C17.6569 20 15.7712 20 12 20ZM9.57572 9.57574C9.81003 9.34142 10.1899 9.34142 10.4242 9.57574L12 11.1515L13.5757 9.57575C13.81 9.34144 14.1899 9.34144 14.4242 9.57575C14.6586 9.81007 14.6586 10.19 14.4242 10.4243L12.8485 12L14.4242 13.5757C14.6585 13.81 14.6585 14.1899 14.4242 14.4242C14.1899 14.6586 13.81 14.6586 13.5757 14.4242L12 12.8485L10.4243 14.4243C10.19 14.6586 9.81005 14.6586 9.57574 14.4243C9.34142 14.1899 9.34142 13.8101 9.57574 13.5757L11.1515 12L9.57572 10.4243C9.3414 10.1899 9.3414 9.81005 9.57572 9.57574Z",
    fill: "#B06D77"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeleteSquare);
export default __webpack_public_path__ + "static/media/delete-square.30a3883e.svg";
export { ForwardRef as ReactComponent };